import { Moment } from 'moment';

import { parseTypedTime } from './typedTime';

export type EndTimeRow = { index: number; duration: number };

// The end-time list: which of the picker's rows to show, in order from the start, each with how long the event would
// last in minutes. A row's own time decides that. Its place in the list can't: the picker counts its rows from today's
// midnight and the start was counted from the event's, and a day the clocks change has 23 or 25 hours, so either day
// being one put the whole list an hour off. A time that day doesn't have, or that the list repeats, is left out.
export const endTimeRows = (times: string[], start: Moment): EndTimeRow[] => {
  const from = start.clone().startOf('minute');
  const fromMinute = from.hours() * 60 + from.minutes();
  const seen = new Set<number>();
  const rows: EndTimeRow[] = [];

  times.forEach((text, index) => {
    const time = parseTypedTime(text);
    if (!time) return;
    const minute = time.hours * 60 + time.minutes;
    if (seen.has(minute)) return;
    seen.add(minute);

    const end = from
      .clone()
      .add(minute > fromMinute ? 0 : 1, 'day')
      .hours(time.hours)
      .minutes(time.minutes);
    if (end.hours() !== time.hours) return;
    rows.push({ index, duration: end.diff(from, 'minutes') });
  });

  return rows.sort((a, b) => a.duration - b.duration);
};
